import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ISettings } from 'app/_models/ISettings';
import { IWidget } from 'app/_models/IWidget';
import { Chart, ChartType, CategoryScale, Colors, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
Chart.register(CategoryScale, Colors, LinearScale, BarElement, Title, Tooltip, Legend);
Chart.defaults.font.family = 'Poppins';

@Component({
  selector: 'chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {
  //#region Fields
  @Input() settings!: ISettings;
  @Input() widget!: IWidget;
  @Input() maximised!: boolean;
  chart: any;
  @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;  
  chartType: ChartType = 'line';
  chartData: any;
  chartOptions: any;
  //#endregion

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    let colours = ['#72b92b', '#1e305a', '#ea8c20', '#03a9f4', '#ffd740'];    
    if (this.widget.type == 'Pie Chart') this.chartType = 'pie';
    if (this.widget.type == 'Bar Chart') this.chartType = 'bar';
    let labels: any[] = [];
    let datasets: any[] = [];
    let chartData = this.widget.chartData;

    if (chartData.length > 0) {
      let keys = Object.keys(chartData[0]);
      let labelKey = keys[0];
      let datasetKeys = keys.slice(1);

      labels = chartData.map((item: any) => {
        let a = item[labelKey];
        if (this.isValidDateString(a)) a = this.formatDate(a);
        return a;
      });

      datasets = datasetKeys.map((datasetKey: string, index: number) => {
        let data = chartData.map((item: any) => item[datasetKey]);
        return {
          label: datasetKey,
          data: data,
          backgroundColor: this.chartType == 'pie' ? colours : '',
          borderColor: this.chartType == 'pie' ? colours : '',
          borderWidth: 1,
          pointBackgroundColor: '#72b92b',
          pointBorderColor: '#72b92b'
        };
      });

      if (this.chartType != 'pie') {
        let colourIndex = 0;
        for (let i = 0; i < datasets.length; i++) {
          if (colourIndex == 4) colourIndex = 0;

          datasets[i].backgroundColor = colours[colourIndex];
          datasets[i].borderColor = colours[colourIndex];
          colourIndex++;
        }
      }
    }

    this.chartData = { labels: labels, datasets: datasets };
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          display: this.maximised ? true : false,
          labels: {
            color: this.settings.darkModeSetting ? '#ffffff' : 'rgb(103 103 103)'
          }
        },
        title: {
          display: this.maximised ? true : false,
          text: this.widget.caption,
          color: this.settings.darkModeSetting ? '#ffffff' : 'rgb(103 103 103)'
        }
      },
      scales: {
        x: {
          ticks: {
            display: this.maximised && this.chartType != 'pie' ? true : false,
            color: this.settings.darkModeSetting ? '#ffffff' : 'rgb(103 103 103)'
          },
          grid: {
            display: this.chartType == 'pie' ? false : true,
            color: this.settings.darkModeSetting ? '#ffffff' : '#dedede'
          },
          border: {
            display: this.chartType == 'pie' ? false : true,
            color: this.settings.darkModeSetting ? '#ffffff' : '#dedede'
          }
        },
        y: {
          ticks: {
            display: this.maximised && this.chartType != 'pie' ? true : false,
            color: this.settings.darkModeSetting ? '#ffffff' : 'rgb(103 103 103)'
          },
          grid: {
            display: this.chartType == 'pie' ? false : true,
            color: this.settings.darkModeSetting ? '#ffffff' : '#dedede'
          },
          border: {
            display: this.chartType == 'pie' ? false : true,
            color: this.settings.darkModeSetting ? '#ffffff' : '#dedede'
          }
        }
      }
    };
  }

  formatDate(value: string): string {
    let dateParts = value.replace('T00:00:00', '').split('-');
    let formattedDate = `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;//yyyy/mm/dd

    if (this.settings.dateFormatSetting == 'dd/MM/yyyy')
      formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;

    if (this.settings.dateFormatSetting == 'MM/dd/yyyy')
      formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;

    return formattedDate;
  }

  isValidDateString(value: string): any {
    let d = new Date(value);
    return d instanceof Date && !isNaN(d.getTime());
  }
}